<template>
  <div class="page">
    <el-form
      :inline="true"
      :model="formInline"
      label-position="left"
      class="demo-form-inline"
    >
      <el-form-item label="资讯标题">
        <el-input v-model="formInline.title" placeholder="资讯标题"></el-input>
      </el-form-item>

      <el-form-item label="栏目名称">
        <el-select v-model="formInline.type" placeholder="栏目名称" clearable>
          <el-option
            v-for="item in columnList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="是否发布">
        <el-select v-model="formInline.status" placeholder="是否发布">
          <el-option label="是" value="1"></el-option>
          <el-option label="否" value="0"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="发表时间">
        <el-date-picker
          v-model="formInline.publicTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="发布时间">
        <el-date-picker
          v-model="formInline.createTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getTableData">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      height="505"
      border
      style="width: 98%; overflow: auto"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="title" label="标题" width="500">
        <template slot-scope="scope">
          <span
            @click="jumpDetails(scope.row.id)"
            v-html="scope.row.title"
            class="title"
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="source" label="出处" width="200">
      </el-table-column>
      <el-table-column prop="publishTime" label="发表时间" width="200">
      </el-table-column>
      <el-table-column prop="createTime" label="在平台的发布时间" width="200">
      </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button
            @click="handleDelete(scope.row.id)"
            type="text"
            size="small"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination" ref="page">
      <pagination
        style="padding: 0px"
        :total="total"
        :page.sync="queryParams.pageNo"
        :page-sizes="[8, 10, 20, 50]"
        :limit.sync="queryParams.pageSize"
        @pagination="getTableData"
      />
    </div>
  </div>
</template>

<script>
import { deleteSolr, articlePageAdmin, articleTypeList } from "@/api/api";
export default {
  data() {
    return {
      tableData: [],
      formInline: {
        keywords: "",
        title: "",
        name: "",
        status: "0",
        type: "",
        sort: "",
        sourceDate: "",
        subTypeName: "",
        publicTime: [],
        createTime: [],
      },
      queryParams: {
        pageNo: 1,
        pageSize: 8,
        offset: "",
        order: "",
        sidx: "",
      },
      total: 0,
      columnList: [],
    };
  },
  mounted() {
    this.getColumnList();
    this.getTableData();
  },
  methods: {
    jumpDetails(id) {
      let routerUrl = this.$router.resolve({
        path: "/articleDetails",
        query: { id },
      });
      window.open(routerUrl.href);
    },
    // 获取表格数据
    getTableData() {
      let createTime = "";
      let publicTime = "";
      if (this.formInline.createTime?.length > 0) {
        createTime =
          this.formInline.createTime[0] + "_" + this.formInline.createTime[1];
      }
      if (this.formInline.publicTime?.length > 0) {
        publicTime =
          this.formInline.publicTime[0] + "_" + this.formInline.publicTime[1];
      }
      articlePageAdmin({
        condition: { ...this.formInline, createTime, publicTime },
        ...this.queryParams,
      }).then((res) => {
        this.tableData = res.data.list;
        this.total = res.data.total;
      });
    },
    getColumnList() {
      articleTypeList().then((res) => {
        if (res.data.code === 200) {
          let list = res.data.data;
          list.map((item) => {
            this.columnList.push({
              label: item.name,
              value: item.solrKey.toString(),
            });
          });
        }
      });
    },
    // 删除
    handleDelete(id) {
      this.$confirm("确定删除此资讯吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteSolr({ id }).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.queryParams.pageNo = 1;
              this.getTableData();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSearch() {
      this.queryParams.pageNo = 1;
      this.getTableData();
    },
    handleSelectionChange() {},
  },
};
</script>

<style scoped lang="scss">
.page {
  position: relative;
  width: 100%;
  height: 100%;
  .pagination {
    width: 100%;
    margin-top: 10px;
    text-align: right;
    padding-right: 20px;
  }
}

.title {
  cursor: pointer;
  &:hover {
    color: #13509f;
  }
}
</style>
